export function isDialog(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "behavior" in candidate &&
        "content" in candidate);
}
export function isDialogBehavior(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "displayDuration" in candidate &&
        "target" in candidate &&
        "timing" in candidate);
}
export function isDialogContent(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "body" in candidate &&
        "button" in candidate &&
        "title" in candidate);
}
